import React from 'react'
import { ViewStyle } from 'react-native'

import styled from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

type MessengerUtilityItemEmptyStateProps = {
  text: React.ReactNode
  style?: ViewStyle
}

const Container = styled.View(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.colors.backgroundSecondary,
}))

const TextContainer = styled(BodyText)(({ theme }) => ({
  maxWidth: '460px',
  padding: theme.spacing['16px'],
}))

const MessengerUtilityItemEmptyState: React.FC<MessengerUtilityItemEmptyStateProps> = ({ style, text }) => {
  return (
    <Container style={style} testID={tID('MessengerUtilityItemEmptyState')}>
      <TextContainer size={BodyTextSize.LARGE} text={text} textAlign='center' />
    </Container>
  )
}

export default MessengerUtilityItemEmptyState
